<script setup lang="ts">
/**
 * A block cube (same glyph as the Blocks tab) with a small badge in its bottom-right
 * corner — the way AutoCAD marks a block that carries something extra.
 *
 * Used for the two block buttons of the selection bar:
 *   - dynamic block properties → lightning badge
 *   - block attributes         → "Aa" badge
 */
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

withDefaults(
  defineProps<{
    /** Phosphor icon name of the badge. */
    badge: string;
    /** CSS color of the badge. */
    badgeColor: string;
    badgeSize?: number;
    /** Size of the cube itself — smaller in the activity feed than on a button. */
    size?: number;
  }>(),
  { badgeSize: 13, size: 20 },
);
</script>

<template>
  <span class="block-badge-icon">
    <PhosphorIcon name="cube" :size="size" />
    <PhosphorIcon
      class="badge-glyph"
      :name="badge"
      weight="fill"
      :size="badgeSize"
      :style="{ color: badgeColor }"
    />
  </span>
</template>

<style lang="scss" scoped>
.block-badge-icon {
  position: relative;
  display: inline-flex;
}

.badge-glyph {
  position: absolute;
  right: -6px;
  bottom: -4px;
  // Dark outline so the badge stays readable over the cube's edges.
  filter: drop-shadow(0 0 1px var(--canvas-bg))
    drop-shadow(0 0 1px var(--canvas-bg));
}
</style>
